import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RouterModule } from '@angular/router';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CalendarModule } from 'primeng/calendar';
import { TimeKeepingService } from '../../../shared/services/time-keeping.service';
import { ToastService } from '../../../shared/services/toast.service';
import moment from 'moment';
import { PipesModule } from '../../pipes/pipes.module';
@Component({
  selector: 'app-timesheet-editor',
  standalone: true,
  imports: [
    CalendarModule,
    InputTextareaModule,
    InputSwitchModule,
    FloatLabelModule,
    DialogModule,
    ButtonModule,
    FormsModule,
    InputTextModule,
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    RouterModule,
    PipesModule
  ],
  templateUrl: './timesheet-editor.component.html',
  styleUrl: './timesheet-editor.component.scss'
})
export class TimesheetEditorComponent implements OnInit {
  timesheetEditorForm!: FormGroup;
  @Input() selectedRole: any;
  @Input() roles: any;
  @Input() isEdit: any;
  @Input() data: any;
  @Input() reviewerName = '';
  @Input() from = '';
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  selectedTimezone: any = null;
  duration = '--:--';
  constructor(
    private fb: FormBuilder,
    private timeKeepingService: TimeKeepingService,
    private toast: ToastService,
  ) { }

  ngOnInit() {
    this.initializeForm();
    
  }
  initializeForm() {
    this.timesheetEditorForm = this.fb.group({
      notes: [this.isEdit ? this.data.notes : ''],
      isCurrentlyWorking: [!!(this.data?.onTheClock)],
      selectedRole: [this.selectedRole],
      end_date: [this.isEdit ? new Date(this.data.end) : new Date()],
      start_date: [this.isEdit ? new Date(this.data.start) : new Date()],
      start_time: [this.isEdit ? new Date(this.data.start) : new Date()],
      end_time: [this.isEdit ? new Date(this.data.end) : new Date()],
    });

    if(this.from === 'firm-manager'){
      this.selectedTimezone = this.data?.selectedTimezone || null;
    }

    this.timesheetEditorForm.valueChanges.subscribe(() => {
      this.duration = this.calculateDuration();
    });
    this.duration = this.calculateDuration();
   this.disableField('selectedRole');
    if(this.data?.onTheClock || this.data?._id){
      this.disableField('isCurrentlyWorking');
    }
  }
  onSubmit() {
    const timeSheetData = this.timesheetEditorForm.value
    const startTime = this.timesheetEditorForm.value.start_time.toLocaleTimeString([], { hour12: false });
    const endTime = this.timesheetEditorForm.value.end_time.toLocaleTimeString([], { hour12: false });
    const st = startTime.split(':');
    const et = endTime.split(':');
    const start_date = timeSheetData.start_date;
    start_date.setHours(st[0]);
    start_date.setMinutes(st[1]);
    start_date.setSeconds(st[1]);
    const end_date = timeSheetData.end_date;
    end_date.setHours(et[0]);
    end_date.setMinutes(et[1]);
    end_date.setSeconds(et[1]);

    if (this.isEdit) {
        const body: any = {
          end_date: this.data?.onTheClock ? '' : moment(end_date).set("seconds", 0).format(),
          start_date: !timeSheetData.isCurrentlyWorking ? moment(start_date).set("seconds", 0).format() : '',
          role_id: this.selectedRole.value,
          notes: timeSheetData.notes || '',
          timezone: moment().tz(moment.tz.guess()).format('z'),
          id: this.data._id,
          is_latest: this.data.isLatest,
        };

        if(this.selectedTimezone){
          body.timezone = this.selectedTimezone.offset;
          body.timezoneAbbrevation = this.selectedTimezone.val;


          body.start_date = this.getMomentFormatByTimeZone(timeSheetData.start_date, timeSheetData.start_time, this.selectedTimezone.id || body.timezoneAbbrevation)
          body.end_date = this.getMomentFormatByTimeZone(timeSheetData.end_date, timeSheetData.end_time, this.selectedTimezone.id || body.timezoneAbbrevation)
        }

        this.timeKeepingService.updateTSheet(body).subscribe((d: any) => {
          this.toast.showSuccess('Time updated Successfully');
          this.cancel(true);
        })
    } else {
        const body = {
          end_date: timeSheetData.isCurrentlyWorking ? '' : moment(end_date).set("seconds", 0).format(),
          start_date: moment(start_date).set("seconds", 0).format(),
          role_id: this.selectedRole.value,
          notes: timeSheetData.notes,
          timezone: moment().tz(moment.tz.guess()).format('z')
        };
        this.timeKeepingService.addTSheet(body).subscribe((d: any) => {
          this.toast.showSuccess('Time added Successfully');
          this.cancel(true);
        })
    }

  }
  cancel(data: any) {
    this.closeModal.emit(data);
  }

  disableField(controlName: string): void {
    const control = this.timesheetEditorForm.get(controlName);
    if (control) {
      control.disable();
    }
  }

  calculateDuration(): string {
    try {
      const v = this.timesheetEditorForm.getRawValue();
      const startDate: Date | null = v.start_date;
      const startTime: Date | null = v.start_time;
      const endDate: Date | null = v.end_date;
      const endTime: Date | null = v.end_time;

      if (!startDate || !startTime || !endDate || !endTime) return '--:--';

      const start = new Date(startDate);
      start.setHours(startTime.getHours(), startTime.getMinutes(), 0, 0);

      const end = new Date(endDate);
      end.setHours(endTime.getHours(), endTime.getMinutes(), 0, 0);

      const diffMs = end.getTime() - start.getTime();
      if (diffMs <= 0) return '--:--';

      const totalMinutes = Math.floor(diffMs / 60000);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    } catch {
      return '--:--';
    }
  }

  getMomentFormatByTimeZone(date: any, time: any, timezone: string) {
      const timeZoneStr = timezone.split('[')[0];
      const momentDateByTimezone = moment.tz(timeZoneStr);
      const momentDate = moment(date, "MM/DD/YYYY").isValid() ? moment(date, "MM/DD/YYYY") : moment(date);
      const momentTime = moment(time);

      const originalDate = momentDate.date();

      // Set all date components at once to avoid auto-correction issues
      momentDateByTimezone.set({
          year: momentDate.year(),
          month: momentDate.month(),
          date: momentDate.date(),
          hour: momentTime.hour(),
          minute: momentTime.minute(),
          second: 0
      });

      // Check if date rolled over to 1 due to timezone conversion
      if (originalDate !== 1 && momentDateByTimezone.date() === 1) {
          // Date was rolled over, need to increment month
          const currentMonth = momentDateByTimezone.month();
          const currentYear = momentDateByTimezone.year();
          
          if (currentMonth === 11) { // December (0-based)
              // Roll over to next year
              momentDateByTimezone.month(0); // January
              momentDateByTimezone.year(currentYear + 1);
          } else {
              // Normal month increment
              momentDateByTimezone.month(currentMonth + 1);
          }
      }

      return momentDateByTimezone.format();
  }
}
